import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import * as styles from './ListItem.scss';

var ListItem = /*#__PURE__*/function (_Component) {
  _inherits(ListItem, _Component);

  var _super = _createSuper(ListItem);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _super.apply(this, arguments);
  }

  _createClass(ListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          link = _this$props.link,
          modal = _this$props.modal,
          text = _this$props.text,
          onClick = _this$props.onClick,
          component = _this$props.component;
      var item = null;

      if (link) {
        if (modal) {
          item = /*#__PURE__*/React.createElement(Link, {
            className: styles.link,
            to: {
              pathname: link,
              state: {
                modal: true
              }
            }
          }, text);
        } else {
          item = /*#__PURE__*/React.createElement(Link, {
            className: styles.link,
            to: link
          }, text);
        }
      } else if (onClick) {
        item = /*#__PURE__*/React.createElement("span", {
          onClick: onClick,
          className: styles.link
        }, text);
      } else {
        item = /*#__PURE__*/React.createElement("span", {
          className: styles.link
        }, text);
      }

      var itemBody;

      switch (text) {
        case 'divider':
          itemBody = /*#__PURE__*/React.createElement("div", {
            className: styles.divider
          });
          break;

        default:
          itemBody = /*#__PURE__*/React.createElement("div", {
            className: styles.item
          }, item, this.props.onDelete ? /*#__PURE__*/React.createElement("div", {
            className: styles["delete"],
            onClick: this.props.onDelete
          }, /*#__PURE__*/React.createElement("i", {
            className: "icon ion-ios-close-empty"
          })) : '');
      }

      return /*#__PURE__*/React.createElement("div", null, component || itemBody);
    }
  }]);

  return ListItem;
}(Component);

_defineProperty(ListItem, "propTypes", {
  link: PropTypes.string,
  onClick: PropTypes.func,
  text: PropTypes.string.isRequired,
  onDelete: PropTypes.func,
  component: PropTypes.node
});

export default ListItem;